import React from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import { ReactComponent as UserIcon } from "../../../images/icons/user-icon.svg";
import { ReactComponent as InviteIcon } from "../../../images/icons/invite.svg";
import { ReactComponent as DownloadIcon } from "../../../images/icons/download-icon.svg";
import InviteUser from "../Includes/InviteUser.jsx";
import ResentInvitations from "../Includes/ResentInvitations.jsx";
import BulkImportModal from "./BulkImportModal";

/**
 * User Action Buttons Component
 * Contains action buttons for creating users, inviting, bulk import, and export
 */
const UserActionButtons = ({
  // Invite modal props
  isModalOpen,
  setIsModalOpen,
  isMailLoading,
  emails,
  handleAddEmail,
  handleEditEmail,
  handleSubmit,
  handleCloseModal,
  pendingInvitesCountLoading,
  userPendingInvitesCount,
  navigate,
  roleId,
  roleDropdownOpen,
  setRoleDropdownOpen,
  handleToggleRoleDropdown,
  roleDropdownRef,
  userTypeDropdownOpen,
  handleToggleUserTypeDropdown,
  userTypeDropdownRef,
  userType,
  handleUserTypeOptionClick,
  email,
  setEmail,
  emailValidation,
  setEmailValodation,
  selectValidation,
  dletImage,
  addicon,
  handleRemoveEmail,
  handleRemoveLatestEmail,
  emailInputRef,
  // Resend modal props
  isResendModalOpen,
  setIsResendModalOpen,
  handleCloseResendModal,
  handleResendEmails,
  alreadySentEmailsList,
  handleRemoveResendEmail,
  crssrImage,
  // Bulk import props
  isBulkImportModalOpen,
  setIsBulkImportModalOpen,
  bulkImportFileName,
  handleBulkImportUpload,
  handleUpload,
  isBulkImportLoading,
  handleBulkImportCloseModal,
  // Export props
  exportToExcel,
}) => {
  const [isMobile, setIsMobile] = React.useState(
    () => typeof window !== "undefined" && window.innerWidth <= 767
  );

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleBulkImportOpenModal = () => {
    setIsBulkImportModalOpen(true);
  };

  return (
    <div className="button-sec-invoice">
      <Link to="/user/register" aria-label="Create new user">
        <span className="icon-invoice">
          <UserIcon aria-hidden="true" />
        </span>
        Create User
      </Link>

      <a
        className="btn-forpop-initem"
        onClick={handleOpenModal}
        role="button"
        tabIndex={0}
        aria-label="Invite users"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleOpenModal();
          }
        }}
      >
        <span className="icon-invoice">
          <InviteIcon aria-hidden="true" />
        </span>
        Invite Users
      </a>

      {isMobile ? (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={!isMailLoading ? handleCloseModal : undefined}
          closeTimeoutMS={480}
          contentLabel="Invite a User"
          className="mobile-invite-bottom-sheet"
          overlayClassName="mobile-invite-overlay"
          style={{
            content: {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              top: "auto",
              inset: "auto 0px 0px 0px",
              width: "100%",
              maxWidth: "100vw",
              margin: 0,
              padding: 0,
              border: "none",
              borderTopLeftRadius: "30px",
              borderTopRightRadius: "30px",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderRadius: "30px 30px 0 0",
              background: "#FFFFFF",
              outline: "none",
              maxHeight: "90dvh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            },
            overlay: {
              zIndex: 99999,
              position: "fixed",
              inset: 0,
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.45)",
            },
          }}
        >
          <InviteUser
            isMobile={true}
            emails={emails}
            handleAddEmail={handleAddEmail}
            handleEditEmail={handleEditEmail}
            handleSubmit={handleSubmit}
            handleCloseModal={handleCloseModal}
            isMailLoading={isMailLoading}
            pendingInvitesCountLoading={pendingInvitesCountLoading}
            userPendingInvitesCount={userPendingInvitesCount}
            navigate={navigate}
            roleId={roleId}
            roleDropdownOpen={roleDropdownOpen}
            setRoleDropdownOpen={setRoleDropdownOpen}
            handleToggleRoleDropdown={handleToggleRoleDropdown}
            roleDropdownRef={roleDropdownRef}
            userTypeDropdownOpen={userTypeDropdownOpen}
            handleToggleUserTypeDropdown={handleToggleUserTypeDropdown}
            userTypeDropdownRef={userTypeDropdownRef}
            userType={userType}
            handleUserTypeOptionClick={handleUserTypeOptionClick}
            email={email}
            setEmail={setEmail}
            emailValidation={emailValidation}
            setEmailValodation={setEmailValodation}
            selectValidation={selectValidation}
            dletImage={dletImage}
            addicon={addicon}
            handleRemoveEmail={handleRemoveEmail}
            handleRemoveLatestEmail={handleRemoveLatestEmail}
            emailInputRef={emailInputRef}
          />
        </Modal>
      ) : (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={!isMailLoading ? handleCloseModal : undefined}
          contentLabel="Invite a User"
          className="user-invite-modal-main-outer"
          style={{
            content: {
              height: "41%",
              width: "30%",
              position: "fixed",
              top: "50%",
              left: "50%",
            },
          }}
        >
          <InviteUser
            isMobile={false}
            emails={emails}
            handleAddEmail={handleAddEmail}
            handleEditEmail={handleEditEmail}
            handleSubmit={handleSubmit}
            handleCloseModal={handleCloseModal}
            isMailLoading={isMailLoading}
            pendingInvitesCountLoading={pendingInvitesCountLoading}
            userPendingInvitesCount={userPendingInvitesCount}
            navigate={navigate}
            roleId={roleId}
            roleDropdownOpen={roleDropdownOpen}
            setRoleDropdownOpen={setRoleDropdownOpen}
            handleToggleRoleDropdown={handleToggleRoleDropdown}
            roleDropdownRef={roleDropdownRef}
            userTypeDropdownOpen={userTypeDropdownOpen}
            handleToggleUserTypeDropdown={handleToggleUserTypeDropdown}
            userTypeDropdownRef={userTypeDropdownRef}
            userType={userType}
            handleUserTypeOptionClick={handleUserTypeOptionClick}
            email={email}
            setEmail={setEmail}
            emailValidation={emailValidation}
            setEmailValodation={setEmailValodation}
            selectValidation={selectValidation}
            dletImage={dletImage}
            addicon={addicon}
            handleRemoveEmail={handleRemoveEmail}
            handleRemoveLatestEmail={handleRemoveLatestEmail}
            emailInputRef={emailInputRef}
          />
        </Modal>
      )}

      <Modal
        isOpen={isResendModalOpen}
        onRequestClose={!isMailLoading ? handleCloseResendModal : undefined}
        contentLabel="Resend Invitations"
        className="user-invite-modal-main-outer resend-modal-outer"
        style={{
          content: {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "50%",
            left: "50%",
          },
        }}
      >
        <ResentInvitations
          alreadySentEmailsList={alreadySentEmailsList}
          handleRemoveResendEmail={handleRemoveResendEmail}
          handleCloseResendModal={handleCloseResendModal}
          handleResendEmails={handleResendEmails}
          isMailLoading={isMailLoading}
          roleId={roleId}
          crssrImage={crssrImage}
          dletImage={dletImage}
        />
      </Modal>

      <a
        className="btn-forpop-initem bulk-import"
        onClick={handleBulkImportOpenModal}
        role="button"
        tabIndex={0}
        aria-label="Bulk import users"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleBulkImportOpenModal();
          }
        }}
      >
        <span className="icon-invoice">
          <DownloadIcon aria-hidden="true" />
        </span>
        Bulk Import
      </a>

      <BulkImportModal
        isOpen={isBulkImportModalOpen}
        onRequestClose={handleBulkImportCloseModal}
        bulkImportFileName={bulkImportFileName}
        handleBulkImportUpload={handleBulkImportUpload}
        handleUpload={handleUpload}
        isBulkImportLoading={isBulkImportLoading}
      />

      <a
        className="btn-forpop-initem bulk-export"
        onClick={exportToExcel}
        role="button"
        tabIndex={0}
        aria-label="Export user data to Excel"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            exportToExcel();
          }
        }}
      >
        <span className="icon-invoice">
          <DownloadIcon aria-hidden="true" />
        </span>
        Export Data
      </a>
    </div>
  );
};

export default UserActionButtons;

